export default __webpack_public_path__ + "static/media/bc2.9d2fbff4.jpg";